module.exports = __webpack_public_path__ + "static/media/educational-resources-slider-2x.6716bfa4.jpg";